<template>
    <v-content>
        <v-container>
            <Navbar/>
            <HeadCards/>
            <v-space></v-space>
            <v-row>
                <v-col>
                    <TrackedProductsList/>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>

<script>

// Components
import TrackedProductsList from "../components/TrackedProductsList";
import Navbar from "../components/Navbar";
import HeadCards from "../components/HeadCards"

export default {
    name: 'DashVue',
    components:{
        'TrackedProductsList' : TrackedProductsList,
        'Navbar' : Navbar,
        'HeadCards' : HeadCards,
    }
};
</script>

<style scoped>
</style>
